import type { ReactNode } from 'react';

import styles from './CardActions.module.css';

/**
 * The top-right corner of a resource card (board / database, on Home and in a workspace): the
 * favorite star and the "..." menu side by side, always at the same place whatever the title or
 * metadata look like. The card must be `position: relative`.
 */
export function CardActions({ children }: { children: ReactNode }) {
  return <span className={styles.actions}>{children}</span>;
}
